import React, { Component } from 'react';


class Contacts extends Component {
    render() {
        return (
            <section className="contact" id="contact" style={{paddingTop: 10, paddingBottom: 10, paddingRight: 10, backgroundColor: "#ffffff"}}>
                <div className="row no-gutters justify-content-center">
                    <div className="col-11 col-md-6 mb-5 mb-md-3">
                        <div className="content pl-4 pl-md-5">
                            <h4 className="fuente-monserrat h4-text">INFORMACIÓN DE CONTACTO</h4>
                            <p className="fuente-monserrat" style = {{fontSize: 12}}>Av. Río de Janeiro, Cruce con Calle Roraima .Urbanización Chuao, Caracas, Venezuela.</p>
                        <div className="info-contacto">
                            <p className="fuente-monserrat"><strong>Teléfonos:</strong> (0212) 9939139 | (0212) 9910710 | (0212) 9930983</p>
                            <span className="info-contacto-email fuente-monserrat"><strong>Email:</strong> info@iudlm.edu.ve</span>
                        </div>
                        <div className="info-contacto">
                            <h4 className="fuente-monserrat h4-text">CONTROL DE ESTUDIOS</h4>
                            <p className="fuente-monserrat"><strong>Tlf:</strong> (0412) 9614142 | <strong>Email:</strong> control.estudios@iudlm.edu.ve</p>
                        </div>
                        {/* <div className="info-contacto">
                            <h4 className="fuente-monserrat h4-text">ADMINISTRACIÓN</h4>
                            <p className="fuente-monserrat"><strong>Tlf:</strong> (0412) 9614324 | <strong>Email:</strong> administracion@iudlm.com.ve</p>
                        </div> */}

                        <div>
                            <a href="https://www.facebook.com/IUDLM.CCS/" target="_blank" style={{paddingRight: 15,}}><i className="fa fa-facebook-square icons-a"></i></a>
                            <a href="https://twitter.com/iudlmoficial" target="_blank" style={{padding: 15,}}><i className="fa fa-twitter-square icons-a"></i></a>
                            <a href="https://www.instagram.com/iudlmoficial/" target="_blank" style={{padding: 15,}}><i className="fa fa-instagram icons-a"></i></a>
                        </div>
                        </div>
                    </div>
                    <div className="col-11 col-md-6" align="right">
                        <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d62771.53193389757!2d-66.843349!3d10.483257!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x964b15c35913556f!2sInstituto+Universitario+De+Dise%C3%B1o+Las+Mercedes!5e0!3m2!1ses-419!2sve!4v1551282444298"
                        width="600"
                        height="320"
                        frameBorder="0"
                        style={{border : "0", boxShadow:"2px 2px 4px #424242"}}
                        allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </section>
        );
    }
}

export default Contacts;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Contacts.jsx